import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { Modal } from '../../components/ui/view/Modal';
import {
  useGetProductOnlineCoursesQuery,
} from '../../redux-modules/service';
// import { ShareFromSquare } from '../../components/ui/icon/ShareFromSquare';
import { ArrowUpRightFromSquare } from '../../components/ui/icon/ArrowUpRightFromSquare';
import { GraduationCap } from '../../components/ui/icon/GraduationCap';
import { countTags } from '../../util/TagFilter';
import { TagFilterList } from '../../components/ui/view/TagFilterList';
import { ShowMoreLink } from '../../components/ui/view/ShowMoreLink';
import { Picture } from '../../components/ui/Picture';
import { ShareFromSquare } from '../../components/ui/icon/ShareFromSquare';
import { Link } from '../../components/ui/icon/Link';
import { convertMinsToTimestamp } from '../../util/ConvertMinsToTimestamp';
import { VideoIframe } from '../../components/ui/view/VideoIframe';
import { ArrowLeft } from '../../components/ui/icon/ArrowLeft';
import { ArrowRight } from '../../components/ui/icon/ArrowRight';

function ProductDetailOnlineCourses({
  productId,
  loadingText,
}) {
  const {
    data,
    isFetching,
  } = useGetProductOnlineCoursesQuery({ productId });
  const [limit, setLimit] = useState(3);
  const [categoryFilter, setCategoryFilter] = useState(null);

  if (isFetching) {
    return (<div className="container">{loadingText}</div>);
  }

  const { total, translates } = data;
  const { product } = translates;
  let { onlineCourses } = data;

  const categories = countTags(onlineCourses, (item) => item.categories);

  if (categoryFilter) {
    onlineCourses = onlineCourses.filter(
      (onlineCourse) => onlineCourse.categories.indexOf(categoryFilter) !== -1,
    );
  }

  onlineCourses = onlineCourses.slice(0, limit);

  return (
    <div className="section-main">
      <div className="container">
        <div className="section-main-head">
          <div className="row align-item-center">
            <div className="col-12 col-lg">
              <h2>{Craft.t(product, 'Online courses')}</h2>
            </div>
          </div>
        </div>

        <TagFilterList
          tags={categories}
          totalCount={total}
          selectedTag={categoryFilter}
          onTagSelected={(tag) => setCategoryFilter(tag)}
        />

        {onlineCourses.map((onlineCourse) => (
          onlineCourse.videos.map((video, index) => (
            <div key={video.id} className="popup-holder">
              <div className={`main-modal add-indent ${onlineCourse.videos.length > 1 ? 'large' : ''}`} id={`modal-courses-${video.id}`}>
                <div className="main-modal-close-head" />
                <div className="row g-4">
                  <div className={onlineCourse.videos.length > 1 ? 'col-lg-8' : 'col-12'}>
                    <div className="mb-4">
                      <div className="card-curve">
                        <div className={`card-visual ${video.videoIframeSrc ? 'video-wrap ratio ratio-16x9' : ''}`}>
                          {video.modal.thumbnailUrl ? (
                            <img src={video.modal.thumbnailUrl} alt={video.title} loading="lazy" />
                          ) : (
                            <div className="bg-wrap">
                              <Picture image={video.modal} alt={video.title} defaultTransform="lg-min" loading="lazy" />
                            </div>
                          )}
                          {video.videoIframeSrc && (
                            <VideoIframe src={video.videoIframeSrc} />
                          )}
                        </div>
                        <div className="card-body">
                          <div className="frame">
                            <h3>{video.title}</h3>
                            {video.categories.map((category) => (
                              <span key={category} className="text">{category}</span>
                            ))}
                          </div>
                          <span className="mark-video mark-img">
                            <GraduationCap />
                            {video.duration && (
                              <span>{convertMinsToTimestamp(video.duration)}</span>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    {onlineCourse.videos.length > 1 && (
                      <div className="d-flex mb-3 d-lg-none">
                        {onlineCourse.videos[index - 1] && (
                          <a
                            href={`#modal-courses-${onlineCourse.videos[index - 1].id}`}
                            className="main-modal-opener icon-link"
                          >
                            <ArrowLeft width="18" height="13" />
                            {Craft.t(product, 'Previous chapter')}
                          </a>
                        )}
                        {onlineCourse.videos[index + 1] && (
                          <a
                            href={`#modal-courses-${onlineCourse.videos[index + 1].id}`}
                            className="main-modal-opener icon-link ms-auto"
                          >
                            {Craft.t(product, 'Next chapter')}
                            <ArrowRight width="18" height="13" />
                          </a>
                        )}
                      </div>
                    )}
                    {/* eslint-disable-next-line react/no-danger */}
                    <div className="text-black" dangerouslySetInnerHTML={{ __html: video.description }} />
                    {video.link && (
                      <div className="btn-wrap">
                        <a className="btn btn-secondary" href={video.link.url} target="_blank" rel="noreferrer">
                          <ArrowUpRightFromSquare />
                          {video.link.label}
                        </a>
                        <div className="position-relative">
                          <button
                            className="btn-share dropdown-toggle icon-link"
                            type="button"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                            aria-expanded="false"
                          >
                            <ShareFromSquare />
                            <span>
                              &nbsp;
                              {Craft.t(product, 'Share')}
                            </span>
                          </button>
                          <div className="drop-share dropdown-menu">
                            <ul className="list-share">
                              <li>
                                <button type="button" data-clipboard-text={video.link.url}>
                                  <Link />
                                  <span>{Craft.t(product, 'Copy "{provider}" link', { provider: video.link.label })}</span>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {onlineCourse.videos.length > 1 && (
                    <div className="col-lg-4">
                      <h3>{Craft.t(product, 'Chapters')}</h3>
                      <ol className="list-unstyled">
                        {onlineCourse.videos.map((videoLink) => (
                          <li key={`video${videoLink.id}`}>
                            <a href={`#modal-courses-${videoLink.id}`} className={`main-modal-opener d-flex ${videoLink.id === video.id ? 'fw-bold' : ''}`}>
                              {videoLink.duration && (
                                <span className="badge rounded-pill text-bg-dark h-100 mt-1 me-2">
                                  <span>{convertMinsToTimestamp(videoLink.duration)}</span>
                                </span>
                              )}
                              {videoLink.title}
                            </a>
                          </li>
                        ))}
                      </ol>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ))}

        <div className="row spacer-lg">
          {onlineCourses.map((onlineCourse) => (
            <div key={onlineCourse.id} className="col-12 col-lg-6 mb-3b mb-lg-4a d-flex">
              <a className="card-curve main-modal-opener" href={`#modal-courses-${onlineCourse.id}`} data-fancybox="gallery-courses">
                <div className="card-visual">
                  <Picture image={onlineCourse.thumbnail} alt={onlineCourse.title} defaultTransform="xl-min" loading="lazy" />
                </div>
                <div className="card-body">
                  <div className="frame">
                    <h3>{onlineCourse.title}</h3>
                    {onlineCourse.categories.map((category) => (
                      <span key={category}>{category}</span>
                    ))}
                  </div>
                  <span className="mark-video mark-img">
                    <GraduationCap />
                    {onlineCourse.duration && (
                      <span>{convertMinsToTimestamp(onlineCourse.duration)}</span>
                    )}
                  </span>
                  {onlineCourse.videos.length > 1 && (
                    <span className="mark-video mark-img ms-1">
                      {Craft.t(product, '{count} chapters', { count: onlineCourse.videos.length })}
                    </span>
                  )}
                </div>
              </a>
            </div>
          ))}
        </div>
        {limit < total && (
          <ShowMoreLink label={Craft.t(product, 'Show all courses')} onClick={() => setLimit(total)} />
        )}
      </div>
    </div>
  );
}

ProductDetailOnlineCourses.propTypes = {
  productId: PropTypes.string.isRequired,
  loadingText: PropTypes.string.isRequired,
};

export { ProductDetailOnlineCourses };
